import { useState, useEffect } from "react";
import { officesOptions, showFromEmpTable } from "../atoms/atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { accountAtom } from "modules/Login/atoms/AccountAtom";

const OfficeGeneralInformationTable = ({ data, checker }) => {
  const [firstCol, setFirstCol] = useState({});
  const [secondCol, setSecondCol] = useState({});
  const [showFromEmployeeTable] = useRecoilState(showFromEmpTable);
  const officeType =
    data.officeType?.toLowerCase()?.includes("retail") ||
    data.officeType?.toLowerCase()?.includes("franchise");
  const officeOptions = useRecoilValue(officesOptions);
  const ofcRelatedValue = officeOptions?.filter(
    (x) => x.value === data?.officeRelated,
  )[0]?.label;

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const user = useRecoilValue(accountAtom);
  const isFranchise = user.isFranchise;

  useEffect(() => {
    setFirstCol({
      officeName: ["Office Name", data.officeName],
      storeNumber: ["Corporate Office #", data.storeNumber],
      officeCode: ["Office Code", data.officeCode],
      officeType: ["Office Type", data.officeType],
      channel: ["Channel", data.channelC],
      salesType: ["Sales Type", data.salesTypeC],
      officeOrigin: ["Office Origin", data.officeOrigin],
      officeStatus: [
        "Office Status",
        data.officeStatus,
        data.previousOfficeStatusId,
      ],
      officeStatusDetails: ["Office Status Details", data.officeStatusDetails],
      officeRelated: [
        "Office Related to Office Status Details",
        data?.officeRelated ? ofcRelatedValue : "",
      ],
      ...(data?.isConverted &&
        data?.convertedFromOfficeName && {
          convertedFromOffice: [
            "Converted From Office",
            data.convertedFromOfficeName,
          ],
        }),
      phone: ["Phone", data.phone],
      fax: ["Fax", data.fax],
      requiredDataCheck: [
        "Required Office Data Verified",
        !data.address ||
        !data.city ||
        !data.state ||
        !data.zipCode ||
        !data.country ||
        !data.officeCode ||
        !data.phone ||
        !data.mondayStoreHours ||
        !data.tuesdayStoreHours ||
        !data.thursdayStoreHours ||
        !data.wednesdayStoreHours ||
        !data.fridayStoreHours ||
        !data.saturdayStoreHours ||
        !data.sundayStoreHours ||
        !data.bmoId ||
        data.storeNumber ||
        data.officeStatus
          ? "False"
          : "True",
      ],
      previousOfficeStatus: [
        "Previous Office Status",
        data.previousOfficeStatusName,
      ],
    });

    const secondColumns = [
      ["Account Owner", data.accountOwner],
      data?.channelC === "SPLC"
        ? [
            "SPLC Hierarchy",
            <button
              disabled={checker === "true"}
              className={`${checker === "false" && "cursor-pointer"}`}
              onClick={() => {
                const url = "/employeetab/hierarchy";

                history.push({
                  pathname: "/employeetab/hierarchy",
                  state: {
                    splcHierarchyId: data?.splcHierarchyId,
                    officeId: data?.officeId,
                    action: "OfficeToSplcHierarchy",
                    fromEmpTable: showFromEmployeeTable,
                  },
                });
                window.location.reload();
                let userTabs = [];
                [...OfficeTabs].forEach((tabs) => {
                  let temp = [...userPermissions].filter(
                    (user) => user === tabs.permission,
                  );
                  if (temp.length > 0)
                    userTabs.push({
                      to: tabs.to,
                    });
                });
                const index = userTabs.findIndex((c) => c.to === url);
                setSelectedIndex(index);
              }}
            >
              <span
                className={`${
                  checker === "false" && "blueAndBold underline text-xs"
                }`}
              >
                {data.splcHierarchy}
              </span>
            </button>,
          ]
        : [
            "Office Hierarchy",
            <button
              disabled={checker === "true"}
              className={`text-left ${
                checker === "false" ? "cursor-pointer" : ""
              }`}
              onClick={() => {
                const url = "/officesettings/officehierarchy";
                let prevPage = new URLSearchParams(window.location.search).get(
                  "prevPage",
                );
                // For Digital Assets
                if (prevPage) {
                  history.push({
                    pathname:
                      "/officesettings/officehierarchy?prevPage=" + prevPage,
                    state: {
                      officeHierarchyId: data?.officeHierarchyId,
                      officeId: data?.officeId,
                      action: "OHFromOfficeSetting",
                    },
                  });
                } else {
                  history.push({
                    pathname: "/officesettings/officehierarchy",
                    state: {
                      officeHierarchyId: data?.officeHierarchyId,
                      officeId: data?.officeId,
                      action: "OHFromOfficeSetting",
                      fromEmpTable: showFromEmployeeTable,
                    },
                  });
                }
                let userTabs = [];
                [...OfficeTabs].forEach((tabs) => {
                  let temp = [...userPermissions].filter(
                    (user) => user === tabs.permission,
                  );
                  if (temp.length > 0)
                    userTabs.push({
                      to: tabs.to,
                    });
                });
                const index = userTabs.findIndex((c) => c.to === url);
                setSelectedIndex(index);
                localStorage.setItem("ohIdFromOffice", data?.officeHierarchyId);
              }}
            >
              <span
                className={`${
                  checker === "false" && "blueAndBold underline text-xs"
                }`}
              >
                {data.officeHierarchy}
              </span>
            </button>,
          ],
      ["Business Operation", data.businessOperation],
      ["Legal Entity", data.legalEntityName],
      ["Brand", data.brandMarketingName],
      ["Brand ID", data.brandName],
      ["dba", data.dba],
      ["Previous Brand ID", data.previousBrandName],
      ["Acquisition Name", data.acquisitionName],
      ["Tenant ID", data.tenantId],
      ["Attendant Profile", data.attendantProfile],
      ["Agency Management System", data.agencyManagementSystem],
      ["IP Address", data.ipAddress],
      ["Bank", data.bank],
      ["Account", data.account],
    ];

    setSecondCol(secondColumns);
  }, [data]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 text-xs p-2 px-7">
      <div>
        {Object.values(firstCol).map((item, i) => {
          return item[0] === "Sales Type" && !officeType ? (
            ""
          ) : (
            <div key={i} className="w-full border-b border-gray-200 py-1">
              <div className="grid grid-cols-2">
                <label className="expandedLabel fontExpand text-left ml-2">
                  <span className="">{item[0]}:</span>
                </label>
                <span className="expandedData fontExpand ">
                  {item[1] === null || item[1] === "NULL" ? "" : item[1]}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      <div>
        {Object.values(secondCol).map((item, i) => {
          return (
            <div key={i} className="w-full border-b border-gray-200 py-1">
              <div className="grid grid-cols-2">
                <label className="expandedLabel fontExpand text-left ml-2">
                  <span className="">{item[0]}:</span>
                </label>
                <span className="expandedData fontExpand ">
                  {item[1] === null || item[1] === "NULL" ? "" : item[1]}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OfficeGeneralInformationTable;
